import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import DefaultSelect from "../../components/form/DefaultSelect";
import api from "../../utils/axios";
import { fetchUserRoles } from "../../lib/OptionListApi";
import "./UserRoleAssigments.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { ColDef } from "ag-grid-community";
import GridCheckbox from "../../components/GridCheckbox";
import { Button } from "antd";
import { toast } from "react-toastify";
import { UserAccess } from "../../types/UserAccess";
import useLang from "../../hooks/useLang";
import { userRoles } from "../../types/enums";

const UserRoleAssigments = () => {
	let defaultExcelExportSettings = {};
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			filterParams: { excelMode: "windows" },
			autoSizeAllColumns: true,
			wrapText: true,
		}),
		[]
	);
	const [roles, setRoles] = useState<any[]>([]);
	const [roleId, setRoleId] = useState<number | null>(null);
	const [menus, setMenus] = useState<UserAccess[]>([]);
	const [tableColumns, setTableColumns] = useState<ColDef[]>();
	const [editedRows, setEditedRows] = useState<any>(new Map());
	const { strings } = useLang("userRoleAssignment");
	let grid = useRef(null);

	const translateMenuGroupName = (menuGroupId: number): string => {
		switch (menuGroupId) {
			case 1:
				return "Ballina";
			case 2:
				return "Porositë";
			case 3:
				return "Financat";
			case 4:
				return "Barazimet";
			case 5:
				return "Refuzimet";
			case 6:
				return "Llogaritë";
			case 7:
				return "Rregullimet";
			case 8:
				return "Shpagimet";
			default:
				return "Te tjera";
		}
	};
	const translateMenuName = (menuId: number): string => {
		switch (menuId) {
			case 1:
				return "Ballina";
			case 2:
				return "Porositë";
			case 3:
				return "Klient Financat (Per Klientet vetem)";
			case 4:
				return "Barazimet";
			case 5:
				return "Refuzimet";
			case 6:
				return "Porosi të Regjistruara (Per Klientet vetem)";
			case 7:
				return "Porosi në Pritje për Grumbullim (Per Klientet vetem)";
			case 8:
				return "Klientët (Lista e llogarive)";
			case 9:
				return "Shoferët (Lista e llogarive)";
			case 10:
				return "Llogari të Bllokuara";
			case 11:
				return "Llogari të Klientëve Pasivë";
			case 12:
				return "Llogari të reja për Aprovim";
			case 13:
				return "Regjistro Porosi (Per Klientet vetem)";
			case 14:
				return "Shop";
			case 15:
				return "Admin Financat";
			case 16:
				return "Blerësit e ri (Per Klientet vetem)";
			case 17:
				return "Llogaritë Stafi/Administrata";
			case 18:
				return "Rregullimet";
			case 19:
				return "Porosi në Magazinë e Kthimit";
			case 20:
				return "Porosi të Rinisura";
			case 21:
				return "Detajet e Klientit";
			case 22:
				return "Detajet e Shoferit";
			case 23:
				return "Mesazhet";
			case 24:
				return "Skano Porositë";
			case 25:
				return "Tiketat PDF";
			case 26:
				return "Profili";
			case 27:
				return "Shtetet/Qytetet";
			case 28:
				return "Konfigurimi i Çmimeve";
			case 29:
				return "Të Përgjithshme";
			case 30:
				return "Arkivat";
			case 31:
				return "Pastrimi";
			case 32:
				return "Menaxhimi i Shoferëve";
			case 33:
				return "Pagesa e Shoferit";
			case 34:
				return "Caktimi i Roleve";
			case 35:
				return "Menaxhimi i Roleve";
			case 36:
				return "Monedha";
			case 37:
				return "Llogari të Nënklientëve";
			case 38:
				return "Shpagimet";
			case 39:
				return "Ndryshimi i statusit ne: Pritje ose Refuzim";
			case 40:
				return "Ndryshimi i statusit te porosise";
			case 41:
				return "Editimi i detajeve te porosise";
			case 42:
				return "Edito permaset e porosise";
			case 43:
				return "Krijo shpenzim financiar";
			case 44:
				return "Krijo hyrje financiare";
			case 45:
				return "Valido shpenzimet dhe hyrjet financiare";
			case 46:
				return "Proceso Barazimet";
			case 47:
				return "Proceso Refuzimet";
			case 48:
				return "Krijo kerkesen per shpagim";
			case 49:
				return "Konfirmo kerkesen per shpagim";
			case 50:
				return "Refuzo kerkesen per shpagim";
			case 51:
				return "Shpago kerkesen per shpagim";
			case 52:
				return "Ndrysho vleren e porosise";
			case 53:
				return "Regjistrimi i Furnitorëve";
			case 54:
				return "Porosi Internacionale";
			case 55:
				return "'Porosite internacionale'";
			case 56:
				return "Porositë e barazuara";
			case 57:
				return "Harley tiketat";
			case 58:
				return "A4 tiketat";
			case 59:
				return "Raporti Dinamik";
			case 60:
				return "Google Maps Api Key";
			case 61:
				return "Detajet Çmimi i porosisë";
			case 62:
				return "Detajet Çmimi i transportit";
			case 63:
				return "Detajet Shitësi";
			case 64:
				return "Detajet Çmimi real i porosisë";
			case 65:
				return "Detajet Shitësi real";
			case 66:
				return "Detajet Fitimi nga shitja";
			case 67:
				return "Historia e plotë e porosisë";
			case 68:
				return "Historia e shkurtër e porosisë";
			case 69:
				return "Të gjithë shoferët";
			case 70:
				return "Shoferët e zonës";
			case 71:
				return "Detajet Përmasat e porosisë";
			case 72:
				return "Detajet/Filtrimi i porosise per Barazim";
			case 73:
				return "Detajet e porosive Locale vetem";
			case 75:
				return "Ndrysho statusin në: Grumbulluar";
			case 76:
				return "Ndrysho statusin në: Në depo";
			case 77:
				return "Ndrysho statusin në: Në transport";
			case 78:
				return "Ndrysho statusin në: Dorëzuar";
			case 79:
				return "Ndrysho statusin në: Refuzuar";
			case 80:
				return "Ndrysho statusin në: Në pritje";
			case 81:
				return "Ndrysho statusin në: Në pritje për tërheqje";
			case 82:
				return "Ndrysho statusin në: Kthyer";
			case 83:
				return "Ndrysho statusin në: Kthyer në depo";
			case 84:
				return "Ndrysho statusin në: Në transport ndërkombëtar";
			case 85:
				return "Ndrysho statuset e porosive në masë";
			case 86:
				return "Prano porositë lokale";
			case 87:
				return "Porosite internacionale jo-korrekte";
			case 88:
				return "Kodi i dorezimit te porosise";
			case 89:
				return "Filteri Klientët tek Barazimeve";
			case 90:
				return "Filteri Stafi tek Barazimeve";
			case 91:
				return "Filteri Procesuar nga Barazimet";
			case 96:
				return "Fshih Vleren porosise tek porosive internacionale";
			case 97:
				return "Regjistro porosite ne Delivery Express ne pranim ne depo";
			case 100:
				return "Shiko fotot nga makineria e sortimit";
			case 102:
				return "Pikat e agjensise";
			case 104:
				return "Mesazhet (Te Gjitha)";
			case 99:
				return "Lejo mesazhet nga te gjithe klientet";
			case 105:
				return "Numri i identifikimit tek detajet e porosise";
			case 106:
				return "Ndrysho porosinë e kthyer në: Në depo";
			default:
				return "Te tjera";
		}
	};

	const fetchRoles = useCallback(async () => {
		const removedUserRoles = [
			userRoles.CLIENT,
			userRoles.COLLECTOR,
			userRoles.DRIVER,
			userRoles.SUPERDRIVER,
			userRoles.CHATBOT,
			userRoles.INTERNATIONAL_DRIVER,
		];
		try {
			const response = await fetchUserRoles();
			if (response.length > 0) {
				const roleData = response
					?.map((item: any) => ({
						value: item.id,
						label: item.description,
					}))
					.filter(
						(role: any) => !removedUserRoles.includes(role.value)
					);
				setRoles(roleData);
			}
		} catch (error) {}
	}, []);

	const fetchMenus = useCallback(async () => {
		try {
			const response = await api.get("Menu/select-menus", {
				params: { roleId: roleId },
			});
			if (response.status === 200 && response.data) {
				const menuData: UserAccess[] = response?.data.map(
					(menu: UserAccess) => ({
						...menu,
						menuGroupDescription: translateMenuGroupName(
							menu.menuGroupId
						),
						name: translateMenuName(menu.id),
					})
				);
				setMenus(menuData);
			}
		} catch (error) {}
	}, [roleId]);

	useEffect(() => {
		fetchRoles();
		fetchMenus();
		setTableColumns([
			{
				field: "id",
				headerName: strings?.gridColumn.id,
			},
			{
				field: "menuGroupDescription",
				headerName: strings?.gridColumn.menuGroupDescription,
				rowGroup: true,
				hide: true,
			},
			{
				field: "name",
				headerName: strings?.gridColumn.name,
			},
			{
				field: "access",
				headerName: strings?.gridColumn.access,
				cellRenderer: GridCheckbox,
			},
		]);
	}, [fetchMenus, fetchRoles, strings]);

	const roleIdChange = (value: number | null) => {
		setRoleId(value);
		setEditedRows(new Map());
		(grid.current as any).api?.refreshClientSideRowModel();
	};

	const onCellClicked = useCallback(
		(params: any) => {
			const isGroup = params?.node?.group;
			const isAccessColumn = params?.column.colId === "access";

			if (isAccessColumn) {
				if (isGroup) {
				} else {
					params.node.setDataValue("access", !params.value);
					const newEditedRows = new Map(editedRows);
					newEditedRows.set(params.data.id, params.data);
					setEditedRows(newEditedRows);
				}
			}
		},
		[editedRows]
	);

	const menuChangeSave = async () => {
		const menuOption = [...editedRows.values()].map((item: any) => ({
			menuId: item.id,
			status: item.access,
			userRoleId: roleId,
		}));
		try {
			const response = await api.post(
				"Menu/insert-update-menu-option",
				menuOption
			);
			if (response.status === 200) {
				toast.success(strings?.toastMessages.successSave);
				roleIdChange(null);
			}
		} catch (error) {
			console.log(error);
		}
	};
	return (
		<>
			<div className="flex flex-col gap-10">
				<div className="userRoleContainer">
					<DefaultSelect
						label={strings?.select.label}
						placeholder={strings?.select.placeholder}
						flexDirection="col"
						alignCenter="start"
						className="userRoleinput"
						options={roles}
						value={roleId}
						onChange={roleIdChange}
					/>
					<Button
						size="large"
						type="primary"
						style={{
							backgroundColor: "#4F16C2",
							width: 100,
						}}
						onClick={menuChangeSave}
					>
						{strings?.button.save}
					</Button>
				</div>
				<div
					className="ag-theme-alpine"
					style={{
						width: "100%",
						overflow: "auto",
						padding: 8,
					}}
				>
					<AgGridReact
						rowData={roleId ? menus : []}
						columnDefs={tableColumns}
						defaultColDef={defaultColDef}
						undoRedoCellEditing={true}
						undoRedoCellEditingLimit={20}
						suppressCopyRowsToClipboard={true}
						defaultExcelExportParams={defaultExcelExportSettings}
						rowSelection="multiple"
						domLayout="autoHeight"
						ref={grid}
						enableRangeSelection={true}
						cacheQuickFilter={true}
						rowHeight={60}
						onCellClicked={onCellClicked}
					/>
				</div>
			</div>
		</>
	);
};

export default UserRoleAssigments;
